import { render, staticRenderFns } from "./CreateCourseTemplate.vue?vue&type=template&id=5e12dd02&scoped=true&"
import script from "./CreateCourseTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateCourseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CreateCourseTemplate.vue?vue&type=style&index=0&id=5e12dd02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12dd02",
  null
  
)

export default component.exports